/**
 * Aprendizaje guiado para cálculo de dosis (ola 3 · O3.6, auditoría §19: P22, P1).
 * Helpers puros compartidos por la página /dosis y el enlace desde la Biblioteca
 * (tema 25 · Farmacología en urgencias: cálculo de dosis y perfusiones).
 *
 * Interruptor de build: REACT_APP_DOSIS_ENABLED, encendido por defecto y apagable con
 * 'false' (el backend tiene además DOSIS_GUIADA_ENABLED; con cualquiera de los dos
 * apagado la página dice «no disponible»).
 */
import { FLAGS, flagOn } from './featureFlags';

export const RUTA_DOSIS = '/dosis';
export const TEMA_DOSIS = 25;
export const RESPUESTA_MAX_CHARS = 40;

// Leído en cada llamada (CRA lo incrusta en el build; en jest `process.env` es dinámico).
export const isDosisEnabled = () => flagOn(FLAGS.DOSIS);

export const ETIQUETA_NIVEL = {
  ejemplo: 'Ejemplo resuelto',
  completar: 'Completa el paso',
  resolver: 'Resuelve tú',
};

export const etiquetaNivel = (nombre) => ETIQUETA_NIVEL[nombre] || nombre || '';

export const TEXTO_APERTURA =
  'Lee el ejemplo con calma: aquí no hay penalización ni nota. Lo que aprende es completar después el tuyo.';

/** Validación local mínima (el servidor vuelve a validar): número con coma o punto, ≤ 40 caracteres. */
export const validarRespuesta = (texto) => {
  const t = String(texto ?? '').trim();
  if (!t) return { ok: false, error: 'Escribe un resultado o pulsa «No lo sé».' };
  if (t.length > RESPUESTA_MAX_CHARS) return { ok: false, error: `Máximo ${RESPUESTA_MAX_CHARS} caracteres.` };
  if (!/\d/.test(t)) return { ok: false, error: 'Escribe un número (por ejemplo 21 o 62,5).' };
  return { ok: true, error: null };
};

/** Resumen honesto del progreso: «3 de 12 tipos dominados · 5 empezados». */
export const textoResumen = (resumen) => {
  if (!resumen || !Number.isInteger(resumen.total)) return '';
  const d = resumen.dominadas || 0;
  const e = resumen.empezadas || 0;
  return `${d} de ${resumen.total} ${resumen.total === 1 ? 'tipo dominado' : 'tipos dominados'} · ${e} ${e === 1 ? 'empezado' : 'empezados'}`;
};

/** Ruta de vuelta según el origen del enlace. */
export const rutaVolver = (from) => (from === 'biblioteca' ? `/biblioteca?tema=${TEMA_DOSIS}` : '/dashboard');
